import tracker from '../components/tracker/publish'
import { getCurrentPage } from '../preact-components/common'
import globals from '../utils/globals'
import Analytics from '../preact-components/analytics/Analytics'
import browser from './helpers/browser-detection'
import urlGenerator from '../preact-components/utils/urlGenerator'
import { isSpam } from '../services/spamService'

var TextDecoderLite = require('exports-loader?TextDecoderLite!text-encoder-lite') // eslint-disable-line
const base64js = require('base64-js')
const $ = require('jquery')
const Backbone = require('backbone')
const Marionette = require('marionette')
const _ = require('underscore')
const events = require('utils/globalEvents')
const globalEvents = require('utils/globalEvents')

require('backbone-nested-models')
require('components/insided-api')

const TextDecoder = window.TextDecoder || TextDecoderLite

if (Backbone.history) Backbone.history.start()

function onRequire (cb, options, Module) {
  const data = _.extend({}, options.data, { el: options.el })
  if (options.extend) {
    Module = Module.extend(options.extend)
  }
  const mod = new Module(data)
  if (mod.render) {
    mod.render()
  }
  if (cb) return cb(mod)
}

function errorCatcher (fn) {
  return function () {
    if (!IS_LOCAL) { // eslint-disable-line
      try {
        fn.apply(this, arguments)
      } catch (err) {
        if (window.console) console.error(err) // eslint-disable-line no-console
        try { window.Rollbar.error(err) } catch (e) {}
      }
    } else {
      fn.apply(this, arguments)
    }
  }
}

/* eslint-disable global-require */
function initAnything (cb, options) {
  const afterLoad = onRequire.bind(null, cb, options)

  if (options.model) {
    afterLoad(require('libs/models/' + options.model))
  } else if (options.view) {
    afterLoad(require('libs/views/' + options.view))
  } else if (options.helper) {
    afterLoad(require('libs/helpers/' + options.helper))
  } else if (options.component) {
    afterLoad(require('components/' + options.component + '/index'))
  }
}
/* eslint-enable global-require */

function initDataElements (parent) {
  if (!parent) parent = document
  const tagsToRead = ['model', 'helper', 'view', 'component']

  tagsToRead.forEach(type => {
    const allComponents = parent.querySelectorAll(`[data-${type}]`)
    for (let el of allComponents) {
      el = $(el)
      const options = { el: el }
      options[type] = el.data(type)
      options.data = _.extend({}, el.data('data'))
      errorCatcher(initAnything)(null, options)
    }
  })
}

function loadStuff (listOfElementsToLoad, cb) {
  if (!listOfElementsToLoad) return
  if (!_.isArray(listOfElementsToLoad)) {
    listOfElementsToLoad = [listOfElementsToLoad]
  }
  _.each(listOfElementsToLoad, errorCatcher(initAnything.bind(null, cb)))
}

function decodeAndApplyConfig (base64Config) {
  if (!base64Config) return
  const codec = new TextDecoder('utf-8')

  let config
  try {
    config = JSON.parse(codec.decode(base64js.toByteArray(base64Config)))
  } catch (e) {
    console.log('Failed to parse config', e)
  }

  if (config) app.init(config)
}

(function () {
  const bodyClasses = document.getElementsByTagName('body')[0].classList
  let currentPage = 'other'

  if (bodyClasses.contains('parent-category')) {
    currentPage = 'parent category'
  } else if (bodyClasses.contains('category-page')) {
    currentPage = 'category'
  } else if (bodyClasses.contains('twig_page-topic')) {
    currentPage = 'topic'
  } else if (bodyClasses.contains('forum--search')) {
    currentPage = 'search'
  } else if (bodyClasses.contains('twig_default-member-profile')) {
    currentPage = 'profile'
  } else if (bodyClasses.contains('twig_site-badges')) {
    currentPage = 'badges'
  } else if (bodyClasses.contains('twig_default-setting-profile')) {
    currentPage = 'settings'
  } else if (bodyClasses.contains('twig_site-index')) {
    currentPage = 'homepage'
  }

  $('[data-track]').on('click', e => {
    const el = $(e.currentTarget)
    const standardInfo = {
      'Topic Initiated': {
        user_role: window.inSidedData.user.role,
        source: getCurrentPage(),
        button_label: el.text().trim()
      },
      'Sidebar Widget Clicked': {
        click_source: currentPage
      },
      'Destination Configuration Mode Activated': {
        viewport: `${window.innerWidth}*${window.innerHeight}`,
        browser: browser
      }
    }

    const userObject = { user: window.inSidedData.user }
    const data = Object.assign({}, el.data('track'), standardInfo[el.data('track').type], userObject)

    tracker.trackEvent('userevent', data)
  })

  $('[data-ga-track]').on('click', e => {
    const el = $(e.currentTarget)
    const data = el.data('ga-track')
    Analytics.send(data.eventCategory, data.eventAction, data.eventLabel)
  })

  // Event tracker for general settings
  function isChecked (selector) {
    const el = document.querySelector(selector)

    return el ? el.checked : null
  }

  function receivePrivateMessagesCheck (selector) {
    const checkedResult = isChecked(selector)

    if (checkedResult === null) {
      return checkedResult
    } else if (checkedResult) {
      return 'Everyone'
    } else {
      return 'People you follow'
    }
  }

  if (window.location.pathname === '/settings/general') {
    const profileSettingsSaveBtn = document.querySelector('.js-submit-general-settings')

    profileSettingsSaveBtn.addEventListener('click', function () {
      window.insided.trackEvent('userevent', {
        type: 'Profile Settings Saved',
        display_badges: isChecked('#GeneralSettingsForm_showbadges_0'),
        display_reputation: isChecked('#GeneralSettingsForm_showreputation_0'),
        display_usertitle: isChecked('#GeneralSettingsForm_showusertitle_0'),
        display_new_activity: isChecked('#GeneralSettingsForm_showunreadpostscounter_0'),
        notification_new_reply: isChecked('#GeneralSettingsForm_addtofavorites_0'),
        notification_new_topic: isChecked('#GeneralSettingsForm_autosubscribe_0'),
        notification_new_mention: isChecked('#GeneralSettingsForm_mentionnotification_0'),
        notification_best_answer: isChecked('#GeneralSettingsForm_bestanswernotification_0'),
        notification_private_message: isChecked('#GeneralSettingsForm_privatemessagesnotification_0'),
        receive_private_messages: receivePrivateMessagesCheck('#GeneralSettingsForm_receivepmbuddies_0')
      })
    })
  }
})()

const app = {
  $: $,
  Backbone: Backbone,
  Marionette: Marionette,
  _: _.mixin({
    deepExtend: function () {
      return $.extend.apply(
        $,
        [true].concat(Array.prototype.slice.call(arguments, 0))
      )
    }
  }),
  config: {},
  init: loadStuff,
  initDataElements: initDataElements,
  events: events,
  utils: new Marionette.Application(),
  router: Marionette.AppRouter,
  url: '/',
  libs: { topicUrlGenerator: urlGenerator, isSpam: isSpam },
  decodeAndApplyConfig: decodeAndApplyConfig
}

// global event to be triggered from preact
window.addEventListener('GuestUserAction', function () {
  globalEvents.commands.execute('modal:login:show')
}, false)

setTimeout(function () {
  const elementWithConfig = document.getElementById('insided-app')
  if (!elementWithConfig) return

  const base64Config = elementWithConfig.getAttribute('data-config')
  globals('region', elementWithConfig.getAttribute('data-region'))
  globals('environment', elementWithConfig.getAttribute('data-environment'))
  globals('communityId', elementWithConfig.getAttribute('data-communityId'))
  globals('eventLogger', document.getElementById('insided-preact-app')?.getAttribute('data-eventLogger'))

  initDataElements()
  decodeAndApplyConfig(base64Config)
})

window.jQuery = $
window.$ = $
window.app = app

module.exports = app
